enum ResponseCode {

  SUCCESS = "SU",
  NOT_EXISTED_MENU = "NMN",
  NOT_EXISTED_USER = "NUS",
  NOT_EXISTED_ORDER = "NO",
  NOT_EXISTED_OPTION = "NOP",
  NOT_EXISTED_MANAGER = "NMG",
  NOT_EXISTED_ORDER_ITEM = "NOI",
  NOT_EXISTED_POINT_CHARGE = "NPC",
  NOT_EXISTED_ORDER_STATUS = "NOS",
  NOT_EXISTED_ORDER_ITEM_OPTION = "NOIO",

  
  MAIL_FAIL = "MF",
  ORDER_FAIL = "OF",
  REFUND_FAIL = "RF",
  DUPLICATE_ID = "DI",
  DUPLICATE_PIN = "DP",
  SIGN_IN_FAIL = "SF",
  ALREADY_OPTION = "AO",
  PIN_CHECK_FAIL = "PF",
  DATABASE_ERROR = "DBE",
  VALIDATION_FAIL = "VF",
  MENU_PATCH_FAIL = "MPF",
  MENU_CREATE_FAIL = "MCF",
  OPTION_PATCH_FAIL = "OPF",
  POINT_CHARGE_FAIL = "PCF",
  CERTIFICATION_FAIL = "CF",
  OPTION_CREATE_FAIL = "OCF",
  DUPLICATE_NICKNAME = "DN",
  INSUFFICIENT_BALANCE = "IB",
  ALREADY_POINT_CHARGE = "APC",
  CANCEL_POINT_CHARGE_FAIL = "CPF",
  DELETE_POINT_CHARGE_FAIL = "DPF"
}

export default ResponseCode;